<template>
    <div>
        <link href="https://s3-us-west-2.amazonaws.com/test.rsjs.io/cropper.min.css" rel="stylesheet">
        <transition appear name="on-top">
            <div v-if="show" class="v-alert edit-image">
                <header><p>Edit Image</p><div class="x" @click="exit()"></div></header>
                <div class="source" style="display: flex;justify-content: space-around;align-items: center;">
                    <img style="max-width: 95%;max-height: 95%;" />
                </div>
                <div class="sample">
                    <canvas style="max-width: 100%;max-height:100%"></canvas>
                </div>
                <div class="v-btns">
                    <p class="btn b" @click="saveImage">save</p>
                </div>
            </div>
        </transition>
    </div>
</template> 

<script>

import Cropper from 'cropperjs'
import Vue from 'vue'
import WebSoc from '../utils/WebSoc.js';

export default {
    props: {
        resp: {
            default: () => console.log('No resp editImage')
        },
        base64: {
            default: () => { return '' }
        },
        width: {
            default: () => ''
        },
        height: {
            default: () => ''
        },
        ratio: {
            default: () => ''
        }
    },
    data () {
        return {
            show: true,
            local: false,
        }
    },
    mounted () {
        document.body.appendChild(this.$el);
        this.showCropper();
    },
    methods: {
        showCropper () {
            if ( this.base64.startsWith('http') && !this.local ) {
                console.log('this.base64',this.base64);
                this.base64 = 'https://api-v2.dev.memberstar.club/proxyS3?path='+encodeURIComponent(this.base64);
                console.log({
                    base64: this.base64
                });
            } 
            Vue.nextTick(() => {

                var img = this.$el.querySelector('img');
                this.canvas = this.$el.querySelector('canvas');

                img.onload = () => {
                    var updatedCanvas;
                    this.cropper = new Cropper(img,{
                        autoCropArea: 1,
                        aspectRatio:  isNaN(this.ratio) ? NaN : this.width / this.height,
                        crop: (e) => {
                            var updatedCanvas = this.cropper.getCroppedCanvas({ width: this.width, height: this.height });
                            this.canvas.parentElement.replaceChild(updatedCanvas,this.canvas)
                            this.canvas = updatedCanvas;
                        }
                    }) 
                }
                
                img.src = this.base64;
            }); 

        },
        exit () {
            this.show = false;
            setTimeout(() => {
                this.$el.parentElement.removeChild(this.$el)
            },500);
        },
        saveImage () {
            this.exit();
            this.resp({ result: this.canvas.toDataURL(), width: this.canvas.width, height: this.canvas.height });
        }
    }
}

</script>

<style lang="scss">
.v-alert.edit-image {
    width: 900px;
    margin-left: -450px;
    .source,.sample {
        width: 50%;
        float:left;
        height: 500px;
    }
    .sample {
        display: flex;
        align-items: center;
        justify-content: space-around;
        background-color: rgba(100,100,100,0.2);
        canvas { border: 2px solid black; max-width: 448px; max-height: 500px; }
    }
}
</style>